import type { FaireProductEntity } from "../../entity_types/product";

export const p_5m5wq2f4dw: FaireProductEntity = {
  token: "p_5m5wq2f4dw",
  type: "product",
  name: "Blue and White Coastal Mini Polymer Clay Jewelry Charms",
  brandToken: "b_wjpfk5j84w",
  brandName: "Morning Dew Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/bcb025ab4cf528ed6a015845bfa7957600bc0a60af351c0f9f5b8e34c6d615f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcb86447c1c504a824d6312bb77b5585374560fba041f999227819e162424651.jpeg",
    "https://cdn.faire.com/fastly/206e0a92e8b6e37a462710396b8e9454a6b066b43866a3222c398a359739139a.jpeg",
    "https://cdn.faire.com/fastly/b604cb39886e1ea32eae295ce637e0d18eb02573379784a658f9e83de80d7f8b.jpeg",
    "https://cdn.faire.com/fastly/b9127852cca8be413f46c546dc8363564e766a92b1124ae24a5a3a16ae5f901e.jpeg",
    "https://cdn.faire.com/fastly/8467c9e55569bfb4605033d141f3f0985656c4dd323c54ef111247ea55073f2a.jpeg",
    "https://cdn.faire.com/fastly/b5aa58bdfe1859a5040395617310ccf57a461804831d54b49dda93f1e3aef93a.jpeg",
    "https://cdn.faire.com/fastly/1fa41a4bbf748bdcd54164efac0dc3f0cb60cd23899ec5b42a314fe320aefbb0.jpeg",
  ],
  priceDollars: 6,
  description:
    'These handmade polymer clay charms are inspired by classic blue-and-white porcelain and breezy coastal living. Featuring delicate hand-drawn motifs like anchors, florals, lighthouses, shells, hearts, and seaside details, each charm feels like a tiny keepsake from a sunlit shoreline. Crafted from polymer clay, every charm is lightweight and thoughtfully detailed. The gold- or silver-tone loop makes them easy to add to necklaces, bracelets, charm bars, or layered jewelry designs. No two charms are exactly alike, giving each piece its own unique, handcrafted character.\n\nCharms sold individually and range in size from .4 to .75 inches. You may also select "Entire Collection" and you will receive one of each charm from this entire collection. You will have to choose the collection by finish.\n\nPaperclip Chain Necklaces are 16" + a 2" extender with a lobster claw clasp. Paperclip Chain Bracelets are 7". Available in 18K Gold PVD Stainless Steel and Silver Stainless Steel. The 18K Gold jewelry is PVD coated over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish.',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:01.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
